module.exports = __webpack_public_path__ + "img/12.ce7140fc.jpg";